import { ImportProgressSession } from '@store/reducers/accountReducer';
import {
    saveTaskProgressSession,
    loadTaskProgressSession,
    clearTaskProgressSession,
} from './taskProgressStorage';

const STORAGE_KEY = 'icdl_import_progress_session_v1';

export const saveImportProgressSession = (session: ImportProgressSession): void =>
    saveTaskProgressSession(STORAGE_KEY, session);

export const loadImportProgressSession = (): ImportProgressSession | null =>
    loadTaskProgressSession(STORAGE_KEY) as ImportProgressSession | null;

export const clearImportProgressSession = (): void => clearTaskProgressSession(STORAGE_KEY);
